import { AuditorForm } from '../mainFormAuditor/components';
import { ocForm } from './components';
import {
  BasicInfoSupplier,
  ActivityAreaForm,
  DocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  ObjectionSupplier,
  } from '../mainFormForeignSupplier/components';
  import { tabs } from '../mainFormForeignSupplier/components/basicInfoSupplier/tabs';
  // import { getLocalString, localNames } from "utils/localisation.service";
  // import locale from 'antd/lib/date-picker/locale/el_GR';

export const stepsOC = () =>  {
  return [
 {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs(),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 2,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 3,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 4,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    id: 5,
  },
  {
    name: 'OBJECTIONFORM',
    label: 'Ένσταση',
    Component: ObjectionSupplier,
    id: 6,
  },
  {
    name: 'OBJECTIONEVALUATIONFORM',
    label: 'Αξιολόγηση Ένστασης',
    Component: ocForm,
    id: 7,
  },
].filter(item => !item?.hidden)
};